var $8fd1bfa1af5fec0b$exports = {};
const $8fd1bfa1af5fec0b$var$navIconBurger = document.querySelector(".nav-icon-burger");
const $8fd1bfa1af5fec0b$var$navPanel = document.querySelector(".nav-panel");
$8fd1bfa1af5fec0b$var$navIconBurger.addEventListener("click", function() {
    $8fd1bfa1af5fec0b$var$navPanel.classList.toggle("nav-panel-shown");
    $8fd1bfa1af5fec0b$var$navIconBurger.classList.toggle("nav-icon-burger-opened");
});


//# sourceMappingURL=index.e34d2bd2.js.map
